import axiosClient from "./axiosClient";

export const selectionHistoryApi = {
  getUserSelectionHistories: (userId: number) => {
    const url = `api/user-selection-histories/${userId}`;
    return axiosClient.get(url);
  },
  getGroupSelectionHistories: (userId: number) => {
    const url = `api/group-selection-histories/${userId}`;
    return axiosClient.get(url);
  },
  getConstructionSelectionHistories: (userId: number) => {
    const url = `api/construction-selection-histories/${userId}`;
    return axiosClient.get(url);
  },
  storeUserSelectionHistory: (body: any) => {
    const url = `api/user-selection-histories`;
    return axiosClient.post(url, body);
  },
  storeGroupSelectionHistory: (body: any) => {
    const url = `api/group-selection-histories`;
    return axiosClient.post(url, body);
  },
  storeConstructionSelectionHistory: (body: any) => {
    const url = `api/construction-selection-histories`;
    return axiosClient.post(url, body);
  },
 
};
